import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { Subscription } from 'rxjs';
import { CompanyBankAccountService } from '../../../invoice/service/data/company-bank-account.service';
import { CompanyBankAccount } from '../../model/company-bank-account';

@Component({
    selector: 'add-bank-transaction-import-date-form',
    templateUrl: './add-bank-transaction-import-date-form.component.html',
    styleUrls: ['./add-bank-transaction-import-date-form.component.scss'],
    providers: [CompanyBankAccountService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddBankTransactionImportDateFormComponent implements OnInit, OnDestroy {
  constructor(
    private _dialogService: ActionWindowService,
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    private _bankAccountService: CompanyBankAccountService
  ) {}

  @Input() dataContext: {
    companyBankAccount: CompanyBankAccount;
  };

  form: FormGroup;

  ngOnInit() {
    const bankTransactionImportDateControl = this._fc.createMandatory(
      'BANK_IMPORT_TRANSACTIONS.IMPORTED_AT',
      this.dataContext.companyBankAccount.bankTransactionsImportStartDate
    );

    this.form = this._fb.group({
      bankTransactionImportDate: bankTransactionImportDateControl,
    });
  }

  cancel() {
    this._dialogService.close();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  private sub: Subscription;
  submitEnabled = true;
  onSubmit() {
    if (this.form.invalid || !this.submitEnabled) {
      return;
    }
    this.submitEnabled = false;
    if (this.sub) {
      this.sub.unsubscribe();
    }

    this.dataContext.companyBankAccount.bankTransactionsImportStartDate = this.form.get('bankTransactionImportDate')?.value;

    this._bankAccountService.updateBankTransactionImportStartDate(this.dataContext.companyBankAccount).subscribe(bankTransaction => {
      this._dialogService.complete(bankTransaction);
    });
  }
}
